import { Delete, Fingerprint, ScanFace } from "lucide-react";

const hapticTap = () => {
  try {
    window?.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.("light");
  } catch {
    /* noop */
  }
};

/**
 * Цифровая клавиатура 3×4 в стиле приложения.
 * Левый нижний слот — биометрия (если передан onBiometric), правый — backspace.
 */
const PinKeypad = ({ onDigit, onBackspace, onBiometric, biometricType, disabled = false }) => {
  // Склейка строк без пробела на стыке давала класс `bg-[var(--lp-tile)]text-2xl`
  // — токен, которого нет ни в одном стиле. Клавиши всё это время были без
  // подложки и с обычным размером цифр.
  const keyClass =
    "mx-auto flex h-16 w-16 items-center justify-center rounded-full " +
    "bg-[var(--lp-tile)] text-2xl font-semibold text-foreground " +
    "transition-transform active:scale-90 " +
    "disabled:opacity-40 disabled:active:scale-100 select-none";

  const BiometricIcon = biometricType === "face" ? ScanFace : Fingerprint;

  const press = (handler) => () => {
    if (disabled || !handler) return;
    hapticTap();
    handler();
  };

  return (
    <div className="grid w-full max-w-[280px] grid-cols-3 gap-y-3 gap-x-6">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => (
        <button
          key={digit}
          type="button"
          className={keyClass}
          onClick={press(() => onDigit(String(digit)))}
          disabled={disabled}
          data-testid={`pin-key-${digit}`}
        >
          {digit}
        </button>
      ))}

      {onBiometric ? (
        <button
          type="button"
          className={`${keyClass} bg-transparent`}
          onClick={press(onBiometric)}
          disabled={disabled}
          aria-label="Biometric unlock"
          data-testid="pin-key-biometric"
        >
          <BiometricIcon className="h-7 w-7 text-link" />
        </button>
      ) : (
        <span aria-hidden="true" />
      )}

      <button
        type="button"
        className={keyClass}
        onClick={press(() => onDigit("0"))}
        disabled={disabled}
        data-testid="pin-key-0"
      >
        0
      </button>

      <button
        type="button"
        className={`${keyClass} bg-transparent`}
        onClick={press(onBackspace)}
        disabled={disabled}
        aria-label="Backspace"
        data-testid="pin-key-backspace"
      >
        <Delete className="h-6 w-6 text-muted-foreground" />
      </button>
    </div>
  );
};

export default PinKeypad;
